import { initPlasmicLoader } from "@plasmicapp/loader-react";
export const PLASMIC = initPlasmicLoader({
  projects: [
    {
      id: "rLrD9ntMHMrLMhcMwKDMas",  // ID of a project you are using
      token: "MsqkbwxrBWiAgv5rfdxOc6tJu4lPMPEgdn3cMoyFmAsGK8OrPDe8NbJYXQc5JsIladq9yXVrESwfsdu8yqA"  // API token for that project
    }
  ],
  // Fetches the latest revisions, whether or not they were unpublished!
  // Disable for production to ensure you render only published changes.
  preview: true,
})